import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import WbSunny from "@material-ui/icons/WbSunny";
import NightsStay from "@material-ui/icons/NightsStay";

import styles from "./styles";

const useStyles = makeStyles(styles);

const Header = ({ links, isNightMode, setNightMode }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const EarnImage = () => {
    return (
      <svg
        width="20"
        height="20"
        style={{ verticalAlign: "bottom" }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.41406 5.89844V7.17824C8.73352 7.42094 8.24219 8.06523 8.24219 8.82812C8.24219 9.79742 9.0307 10.5859 10 10.5859C10.3233 10.5859 10.5859 10.8486 10.5859 11.1719C10.5859 11.4952 10.3233 11.7578 10 11.7578C9.67672 11.7578 9.41406 11.4952 9.41406 11.1719H8.24219C8.24219 11.9348 8.73352 12.5791 9.41406 12.8218V14.1016H10.5859V12.8218C11.2665 12.5791 11.7578 11.9348 11.7578 11.1719C11.7578 10.2026 10.9693 9.41406 10 9.41406C9.67672 9.41406 9.41406 9.15141 9.41406 8.82812C9.41406 8.50484 9.67672 8.24219 10 8.24219C10.3233 8.24219 10.5859 8.50484 10.5859 8.82812H11.7578C11.7578 8.06523 11.2665 7.42094 10.5859 7.17824V5.89844H9.41406Z"
          fill="white"
        />
        <path
          d="M10.5859 0V4.78578C13.0207 5.05973 14.9434 6.98246 15.218 9.41406H20C19.7064 4.38289 15.6179 0.293555 10.5859 0Z"
          fill="white"
        />
        <path
          d="M5.89816 13.2732C5.17652 12.3709 4.72656 11.2426 4.72656 10C4.72656 7.2927 6.78457 5.0816 9.41406 4.78578V0C4.18719 0.304922 0 4.6966 0 10C0 12.5396 0.997422 14.8499 2.56207 16.6093L5.89816 13.2732Z"
          fill="white"
        />
        <path
          d="M19.9989 10.5859H15.2142C14.9184 13.2154 12.7073 15.2734 9.99996 15.2734C8.75734 15.2734 7.62902 14.8235 6.72672 14.1018L3.39062 17.4379C5.15004 19.0026 7.46031 20 9.99996 20C15.3034 20 19.694 15.8128 19.9989 10.5859Z"
          fill="white"
        />
      </svg>
    );
  };

  const PoolImage = () => {
    return (
      <svg
        width="20"
        height="20"
        style={{ verticalAlign: "bottom" }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3793 8.43751C16.1359 8.68126 15.7391 8.68126 15.4957 8.43751L14.6875 7.62931C14.4437 7.38595 14.4437 6.98907 14.6875 6.74571L15.4957 5.93751H4.375C3.34101 5.93751 2.5 6.77853 2.5 7.81251C2.5 8.32931 2.0793 8.75001 1.5625 8.75001H0.9375C0.420704 8.75001 0 8.32931 0 7.81251C0 5.40001 1.9625 3.43751 4.375 3.43751H15.4957L14.6875 2.62931C14.4437 2.38595 14.4437 1.98907 14.6875 1.74572L15.4957 0.937512C15.7391 0.693762 16.1359 0.693762 16.3793 0.937512L19.9086 4.46642C20.0305 4.58868 20.0305 4.78634 19.9086 4.90861L16.3793 8.43751Z"
          fill="#fff"
        />
        <path
          d="M3.6207 11.5625C3.86406 11.3188 4.26055 11.3188 4.5043 11.5625L5.3125 12.3707C5.55672 12.6149 5.55711 13.0097 5.3125 13.2543L4.5043 14.0625H15.625C16.659 14.0625 17.5 13.2215 17.5 12.1875C17.5 11.6707 17.9207 11.25 18.4375 11.25H19.0625C19.5793 11.25 20 11.6707 20 12.1875C20 14.6 18.0375 16.5625 15.625 16.5625H4.5043L5.3125 17.3707C5.55672 17.6149 5.55711 18.0097 5.3125 18.2543L4.5043 19.0625C4.26051 19.3063 3.86445 19.3063 3.6207 19.0625L0.0914059 15.5336C-0.030468 15.4113 -0.030468 15.2137 0.0914059 15.0914L3.6207 11.5625Z"
          fill="#fff"
        />
      </svg>
    );
  };

  const StatsImage = () => {
    return (
      <svg
        width="22"
        height="22"
        style={{ verticalAlign: "bottom" }}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M21.3552 20.7109H20.6677V7.9923C20.6677 7.63635 20.3791 7.34778 20.0232 7.34778H17.4451C17.0891 7.34778 16.8006 7.63635 16.8006 7.9923V20.7109H15.5115V12.2891C15.5115 11.9332 15.2229 11.6446 14.867 11.6446H12.2889C11.9329 11.6446 11.6444 11.9332 11.6444 12.2891V20.7109H10.3553V14.6524C10.3553 14.2964 10.0668 14.0078 9.7108 14.0078H7.13272C6.77677 14.0078 6.48819 14.2964 6.48819 14.6524V20.7109H5.19915V16.1992C5.19915 15.8433 4.91057 15.5547 4.55463 15.5547H1.97654C1.62059 15.5547 1.33201 15.8433 1.33201 16.1992V20.7109H0.644522C0.288574 20.7109 0 20.9995 0 21.3554C0 21.7113 0.288574 21.9999 0.644522 21.9999H21.3552C21.7111 21.9999 21.9997 21.7113 21.9997 21.3554C21.9997 20.9995 21.7111 20.7109 21.3552 20.7109Z"
            fill="#fff"
          />
          <path
            d="M0.644522 13.8497C4.66712 13.8497 9.02933 12.405 12.9277 9.78175C15.9808 7.72723 18.5258 5.1026 20.1067 2.41508L20.7327 4.75112C20.8098 5.0391 21.1824 5.28788 21.522 5.20685C21.8683 5.12426 22.0699 4.76131 21.9777 4.41748L20.9223 0.478586C20.8301 0.134798 20.4769 -0.0693009 20.1329 0.0228658L16.1941 1.07829C15.8502 1.17042 15.6462 1.52383 15.7383 1.86766C15.8305 2.21149 16.1837 2.41559 16.5277 2.32338L19.0652 1.64345C17.5903 4.20633 15.1528 6.73063 12.208 8.71227C8.52011 11.1939 4.41347 12.5606 0.644522 12.5606C0.288574 12.5606 0 12.8492 0 13.2052C0 13.5611 0.288574 13.8497 0.644522 13.8497Z"
            fill="#fff"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="22" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };


  const IDOLogo = (props)=>{
    return <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="22.000000" height="22.000000" viewBox="0 0 1280.000000 1104.000000" preserveAspectRatio="xMidYMid meet"><script xmlns=""/><script xmlns=""/>
  
    <g transform="translate(0.000000,1104.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none">
    <path d="M9644 11026 c-18 -8 -51 -31 -75 -53 -74 -66 -376 -434 -801 -973 -141 -179 -275 -343 -298 -364 -63 -57 -122 -78 -201 -74 -60 3 -76 9 -190 75 -206 118 -324 171 -524 237 -314 102 -653 152 -1119 163 -668 15 -1380 -60 -2351 -248 -378 -73 -419 -63 -672 170 -354 324 -752 650 -864 706 -27 14 -74 31 -103 37 -114 22 -233 -43 -381 -209 -124 -139 -197 -234 -322 -423 -374 -563 -760 -1218 -1131 -1920 -340 -644 -591 -1188 -608 -1318 -14 -106 35 -172 173 -237 161 -75 236 -117 524 -293 467 -284 528 -317 731 -388 98 -34 189 -69 203 -78 36 -24 48 -54 93 -231 96 -379 108 -465 73 -541 -10 -22 -94 -130 -187 -240 -274 -324 -317 -381 -376 -499 -62 -123 -81 -191 -86 -301 -5 -122 8 -192 53 -282 45 -88 99 -149 182 -206 99 -68 194 -98 323 -104 158 -7 295 36 397 123 44 37 435 451 874 925 373 402 376 407 422 499 39 79 42 90 45 187 4 84 0 116 -17 171 -58 190 -208 344 -401 409 -42 14 -84 19 -175 19 -191 0 -291 -38 -505 -194 -85 -62 -126 -87 -131 -78 -7 13 -117 521 -148 686 -19 100 -19 106 -2 160 10 31 189 360 398 731 405 719 691 1236 843 1520 236 444 262 486 358 575 48 45 149 98 237 124 105 31 1088 183 1460 225 343 40 514 50 855 50 206 1 391 -4 460 -11 659 -70 620 -65 620 -88 0 -21 -13 -23 -332 -68 -183 -26 -425 -56 -538 -67 -335 -34 -502 -75 -684 -166 -134 -68 -192 -110 -356 -258 -35 -32 -164 -137 -285 -234 -272 -218 -359 -303 -406 -397 -30 -62 -34 -78 -34 -150 0 -69 5 -88 30 -139 38 -75 116 -154 219 -221 242 -158 459 -223 701 -212 150 7 271 37 454 113 252 104 310 121 566 163 286 48 624 99 940 141 253 35 303 34 387 -4 51 -23 135 -94 1498 -1285 765 -668 1691 -1482 1729 -1521 178 -182 202 -376 73 -588 -68 -113 -190 -221 -372 -331 -102 -62 -175 -86 -239 -77 -94 12 -155 55 -436 302 -487 428 -999 864 -1065 908 -119 80 -203 92 -310 45 -80 -36 -120 -90 -120 -164 0 -65 50 -148 157 -261 26 -28 339 -297 696 -598 371 -314 657 -562 671 -584 40 -62 49 -106 43 -211 -7 -128 -28 -204 -92 -336 -64 -134 -155 -263 -255 -366 -92 -94 -126 -113 -205 -113 -51 -1 -70 5 -126 36 -37 21 -410 313 -830 650 -420 336 -779 622 -798 635 -29 20 -46 23 -125 23 -164 0 -220 -51 -221 -200 0 -88 17 -130 79 -193 78 -80 863 -709 1317 -1055 213 -162 258 -207 302 -300 31 -65 32 -70 31 -202 -1 -232 -59 -395 -184 -520 -161 -161 -394 -196 -599 -90 -67 35 -32 7 -587 466 -527 435 -852 698 -914 741 -113 77 -306 149 -371 138 -85 -15 -138 -94 -139 -208 0 -86 24 -140 94 -204 28 -26 402 -329 830 -673 428 -343 787 -638 797 -655 35 -57 18 -161 -48 -287 -85 -162 -263 -300 -513 -396 -83 -32 -191 -35 -269 -8 -38 13 -219 137 -635 434 -655 468 -635 453 -883 650 l-182 145 20 25 c10 14 94 107 186 208 314 346 362 435 350 654 -14 262 -191 481 -437 541 -141 34 -312 8 -435 -66 -81 -49 -88 -56 -239 -240 -175 -214 -373 -445 -714 -834 -156 -178 -299 -347 -317 -376 -95 -149 -83 -332 35 -518 106 -169 298 -277 492 -277 104 0 168 15 265 61 95 45 186 126 369 330 64 71 119 129 123 129 3 0 134 -95 291 -212 669 -497 839 -623 1095 -806 285 -205 372 -254 520 -297 311 -89 660 7 973 269 175 146 303 338 377 566 46 142 72 163 219 179 227 26 394 104 545 253 200 198 303 426 346 768 26 205 43 244 125 285 425 216 666 560 776 1113 19 95 41 186 49 202 19 37 46 51 171 91 469 148 756 481 845 979 62 340 -32 577 -304 766 -68 47 -146 111 -236 190 -11 10 -1 29 58 110 190 265 327 606 396 984 55 301 72 351 157 465 25 33 155 177 289 320 591 629 649 699 649 780 0 43 -18 93 -47 133 -20 26 -2606 2264 -2837 2455 -105 86 -199 115 -272 83z m169 -622 c34 -18 532 -417 827 -663 262 -219 494 -422 960 -841 223 -201 456 -407 518 -459 112 -92 113 -94 95 -114 -23 -27 -401 -441 -588 -643 -77 -84 -143 -151 -147 -151 -3 1 -561 461 -1240 1021 -678 561 -1235 1021 -1237 1022 -4 4 120 153 473 572 228 269 230 272 268 272 22 0 53 -7 71 -16z m-7324 -226 c25 -23 152 -141 281 -262 129 -122 276 -256 326 -298 58 -49 99 -93 114 -122 23 -42 24 -48 12 -92 -7 -26 -38 -86 -69 -133 -31 -47 -353 -626 -715 -1286 -363 -660 -714 -1298 -780 -1418 -117 -212 -121 -218 -141 -204 -12 8 -233 137 -492 287 -259 150 -475 277 -482 282 -9 7 39 111 184 401 620 1241 1114 2080 1674 2840 19 25 36 46 38 47 2 0 25 -19 50 -42z"/>
    <path d="M3708 4850 c-82 -15 -174 -50 -235 -89 -35 -23 -133 -116 -248 -237 -793 -832 -1114 -1237 -1180 -1489 -21 -78 -21 -232 0 -309 44 -165 173 -321 326 -395 51 -24 118 -47 170 -57 l86 -17 109 54 109 54 289 325 c561 630 1149 1306 1181 1355 45 70 65 143 65 240 0 101 -19 176 -70 274 -68 131 -184 232 -310 272 -73 23 -219 33 -292 19z"/>
    <path d="M4650 3945 c-112 -21 -222 -80 -321 -173 -124 -116 -1156 -1279 -1283 -1446 -83 -109 -136 -260 -136 -385 1 -278 211 -531 488 -588 181 -37 378 40 543 214 26 26 237 271 471 543 936 1092 932 1087 964 1220 44 185 -31 386 -191 507 -144 110 -324 146 -535 108z"/>
    </g>
    <script xmlns=""/></svg>
  }

  const DocsImage = () => {
    return (
      <svg
        width="18"
        height="21"
        style={{ verticalAlign: "bottom" }}
        viewBox="0 0 18 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.0307 2.3772H15.4167V17.4627C15.4167 18.4649 14.6009 19.2807 13.5987 19.2807H7.37718H2.42981V19.8399C2.42981 20.4803 2.94955 21 3.5899 21H9.8092H16.0285C16.6689 21 17.1886 20.4803 17.1886 19.8399V3.53728C17.1886 2.89693 16.671 2.3772 16.0307 2.3772Z"
          fill="#fff"
        />
        <path
          d="M7.3772 18.6228H13.5965C14.2369 18.6228 14.7566 18.1031 14.7566 17.4627V2.37719V1.16009C14.7566 0.519737 14.2369 0 13.5965 0H7.3772H5.30922V0.383772C5.31358 0.423246 5.31579 0.464912 5.31579 0.506579V3.03509V3.68421C5.31579 4.58553 4.58334 5.31798 3.68202 5.31798H3.0329H0.504386C0.471492 5.31798 0.436404 5.31579 0.403509 5.3136H0V17.4627C0 18.1031 0.519737 18.6228 1.16009 18.6228H2.43202H7.3772ZM7.61185 14.6798H3.55702C3.25439 14.6798 3.00877 14.4342 3.00877 14.1316C3.00877 13.8289 3.25439 13.5833 3.55702 13.5833H7.61404C7.91667 13.5833 8.16229 13.8289 8.16229 14.1316C8.16229 14.4342 7.91448 14.6798 7.61185 14.6798ZM11.6689 11.8816H3.55702C3.25439 11.8816 3.00877 11.636 3.00877 11.3334C3.00877 11.0307 3.25439 10.7851 3.55702 10.7851H11.6689C11.9715 10.7851 12.2171 11.0307 12.2171 11.3334C12.2171 11.636 11.9715 11.8816 11.6689 11.8816ZM3.55702 7.8136H11.6689C11.9715 7.8136 12.2171 8.05921 12.2171 8.36184C12.2171 8.66447 11.9715 8.91009 11.6689 8.91009H3.55702C3.25439 8.91009 3.00877 8.66447 3.00877 8.36184C3.00877 8.05921 3.25439 7.8136 3.55702 7.8136Z"
          fill="#fff"
        />
        <path
          d="M0.50377 4.65933H3.68141C3.6836 4.65933 3.68798 4.65933 3.69018 4.65933C4.22088 4.65494 4.6507 4.22512 4.65509 3.69442C4.65509 3.69222 4.65509 3.68784 4.65509 3.68564V0.50582C4.65509 0.21196 4.41386 0.0167847 4.16388 0.0167847C4.04327 0.0167847 3.92266 0.0606443 3.82178 0.161521L0.157278 3.82599C-0.149739 4.13301 0.0673662 4.65933 0.50377 4.65933Z"
          fill="#fff"
        />
      </svg>
    );
  };

  return (
    <AppBar
      className={`${classes.appBar} ${classes.dark}`}
      style={{
        backgroundColor: "#0b0e30",
        boxShadow: "0 0 12px #0b0e30",
        zIndex: "9",
      }}
    >
      <Toolbar className={classes.container}>
        <Button href="/" className={classes.title}>
          <Hidden xsDown>
            <img
              alt="BIFI"
              src={require(`images/single-assets/kite.png`)}
              height={"70px"}
              width="100px"
              position="absolute"
              top="0"
              // className={classes.logo}
            />
            {/* Kite sync */}
          </Hidden>
          <Hidden smUp>
            <img
              alt="BIFI"
              src={require(`images/single-assets/kite.png`)}
              height={"35px"}
              className={classes.logo}
            />
          </Hidden>
        </Button>

        <div className={classes.middleNav}>
          <Hidden smDown>
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "space-around",
              }}
            >
              <a href="/">
                <p
                  style={{
                    marginRight: "30px",
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  <EarnImage />{" "}
                  <span style={{ verticalAlign: "middle" }}>Earn</span>
                </p>
              </a>

              <a href="https://ido.kitesync.app">
                <p style={{ marginRight: "30px", verticalAlign: "middle", cursor: "pointer", color: "white" }}>
                  <IDOLogo  color="#fff"/> <span style={{ verticalAlign: "middle" }}>IDO</span>
                </p>
              </a>

              <a
                href="https://www.dextools.io/app/bsc/pair-explorer/0xede26a1ee14281b58a5238a3ff246b02358a13b6"
                target="_blank"
              >
                <p
                  style={{
                    marginRight: "30px",
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                >
                  <StatsImage />{" "}
                  <span style={{ verticalAlign: "middle" }}>Price Chart</span>
                </p>
              </a>

              {/* <p style={{ marginRight: "30px", verticalAlign: "middle", cursor: "pointer" }}>
                <DocsImage /> <span style={{ verticalAlign: "middle" }}>Docs</span>
              </p> */}
            </div>

            {/* {renderLink('vote', 'vote', 'vote-yea', classes)}
            {renderLink('dashboard', t('stats'), 'chart-bar', classes)}
            {renderLink('docs', 'docs', 'book', classes)} */}
          </Hidden>
          {/* {renderLink('buy', t('buy'), 'dollar-sign', classes)} */}
          {/* {renderBoost(classes)} */}
        </div>

        <Hidden smDown implementation="css">
          <div className={classes.collapse}>{links}</div>
        </Hidden>
        <Hidden mdUp>
          <IconButton
            className={classes.iconButton}
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>

      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper,
          }}
          onClose={handleDrawerToggle}
          // style={{background: "#191D59"}}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            className={classes.closeButtonDrawer}
          >
            <Close />
          </IconButton>
          <div className={classes.appResponsive}>{links}</div>
          <div style={{ textAlign: "left" }}>
            <div
              style={{
                display: "flex",
                flexFlow: "column wrap",
                position: "absolute",
                left: "10%",
                top: "15%",
              }}
            >
              <p
                style={{
                  marginRight: "30px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
              >
                <EarnImage />{" "}
                <span style={{ verticalAlign: "middle" }}>Earn</span>
              </p>
              <p
                style={{
                  marginRight: "30px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
              >
                <PoolImage />{" "}
                <span style={{ verticalAlign: "middle" }}>Pool</span>
              </p>
              <p
                style={{
                  marginRight: "30px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
              >
                <StatsImage />{" "}
                <span style={{ verticalAlign: "middle" }}>Statistics</span>
              </p>

              <p
                style={{
                  marginRight: "30px",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
              >
                <DocsImage />{" "}
                <span style={{ verticalAlign: "middle" }}>Docs</span>
              </p>
            </div>
            {/* <LinkSidebar name="vote" label="vote" icon="vote-yea" classes={classes} />
            <LinkSidebar name="dashboard" label={t('stats')} icon="chart-bar" classes={classes} />
            <LinkSidebar name="docs" label="docs" icon="book" classes={classes} />
            <LinkSidebar name="buy" label={t('buy')} icon="dollar-sign" classes={classes} /> */}
            {/* <IconButton onClick={setNightMode} className={classes.icon}>
              {isNightMode ? <WbSunny /> : <NightsStay />}
            </IconButton> */}
          </div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
};

const renderLink = (name, label, icon, classes) => {
  return (
    <a
      href={getLinkUrl(name)}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.link}
      style={{ marginLeft: "5px", marginRight: "5px", fontSize: "18px" }}
    >
      <i className={`fas fa-${icon} ${classes.icon}`} />
      <span>{label}</span>
    </a>
  );
};

const renderBoost = (classes) => {
  return (
    <a className={classes.btnBoost} href="/stake">
      {/* <img alt="Boost" src={require('images/stake/boost.svg')} /> */}
    </a>
  );
};

const LinkSidebar = ({ name, label, icon, classes }) => (
  <div style={{ width: "100%", paddingTop: "10px" }}>
    {renderLink(name, label, icon, classes)}
  </div>
);

const getLinkUrl = (name) => {
  return name === "buy"
    ? "https://1inch.exchange/#/r/0xF4cb25a1FF50E319c267b3E51CBeC2699FB2A43B/BNB/BIFI/?network=56"
    : `https://${name}.beefy.finance`;
};

export default Header;
